import { apiClient } from '@/lib/api/client'

/** Mirrors ImportedTextLanguageDto (SOLY-IMPORT-003 S10): what a document will print untranslated. */
export interface ImportedTextLanguage {
  language: string
  lines: { title: string; language: string }[]
  categories: string[]
  hasWarning: boolean
}

export function getQuoteVersionLanguageCheck(projectId: string, quoteId: string, versionId: string) {
  return apiClient.get<ImportedTextLanguage>(
    `/v2/projects/${projectId}/quotes/${quoteId}/versions/${versionId}/language-check`
  )
}

export function getFinalInvoiceLanguageCheck(projectId: string) {
  return apiClient.get<ImportedTextLanguage>(`/projects/${projectId}/invoices/final/language-check`)
}

const LANGUAGE_NAMES: Record<string, string> = {
  fr: 'français',
  nl: 'néerlandais',
  de: 'allemand',
  en: 'anglais',
  it: 'italien',
}

/** « nl-BE » → « néerlandais »; an unknown code is shown as it is. */
export function languageName(cultureOrLanguage: string): string {
  const language = cultureOrLanguage.split('-')[0].toLowerCase()
  return LANGUAGE_NAMES[language] ?? language
}

/** « 56 lignes importées restent en français » — one sentence per source language, in the order met. */
export function stayingSentences(check: ImportedTextLanguage): string[] {
  const counts = new Map<string, number>()
  for (const line of check.lines) counts.set(line.language, (counts.get(line.language) ?? 0) + 1)
  return [...counts].map(([language, count]) =>
    count === 1
      ? `1 ligne importée reste en ${languageName(language)}`
      : `${count} lignes importées restent en ${languageName(language)}`
  )
}
